import { useEffect, useState } from "react";
import { useParams } from "next/navigation";
import { useDebounce } from "@/hooks/useDebounce";
import { isAValidEmail } from "@/utils/isAValidEmail";
import { getSearchStudents } from "@/api/dashboard";
import { TagsInput } from "./TagInput";
import styles from "./ModalInput.module.sass";

interface ModalInputProps {
  tag: string;
  setTag: (value: string) => void;
  couponsPermission?: boolean;
}

export const ModalInput = ({ tag, setTag, couponsPermission }: ModalInputProps) => {
  const params = useParams();
  const companyId = params?.companyId || "";
  const [inputValue, setInputValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const searchTerm = useDebounce(inputValue, 300);
  const trimmedValue = inputValue.trim();
  const typeCompleteEmail = trimmedValue !== "" && isAValidEmail(trimmedValue);

  useEffect(() => {
    async function getStudents() {
      const students = await getSearchStudents(companyId, searchTerm);
      if (students?.length > 0) {
        setSearchResult(students);
      } else {
        setSearchResult([]);
      }
    }

    if (searchTerm) {
      getStudents();
    }
  }, [searchTerm]);

  const setNewTag = () => {
    if (typeCompleteEmail) {
      setTag(trimmedValue);
      setInputValue("");
    }
  };

  const setNewSearchTag = (index: number) => {
    setTag(searchResult[index].email);
    setInputValue("");
    setSearchResult([]);
  };

  const cleanRecommendations = () => {
    setSearchResult([]);
  };

  return (
    <div className={styles.ModalInput}>
      <label htmlFor="adminsEmail">
        {couponsPermission ? "Escribe el correo eléctronico" : "Busca entre tu equipo o escribe el correo eléctronico"}
      </label>
      <TagsInput
        id="adminsEmail"
        tag={tag}
        setTag={setTag}
        placeholder="ada@platzi.com"
        customClass={styles.inputTags}
        inputValue={inputValue}
        setInputValue={setInputValue}
        cleanRecommendations={cleanRecommendations}
      />
      {typeCompleteEmail && searchResult?.length === 0 && (
        <div className={styles.Recommendation}>
          <button className={styles.Action} type="button" onClick={setNewTag}>
            <b>Enviar invitación</b>
            <p>Agregar a {inputValue} como administradora</p>
          </button>
        </div>
      )}
      {searchResult?.length > 0 && trimmedValue && (
        <div className={styles.Recommendation}>
          {searchResult.map((user, index) => (
            <button
              key={user.company_user_id}
              className={styles.Action}
              type="button"
              onClick={() => setNewSearchTag(index)}
            >
              <b>{user.name}</b>
              <span>{user.email}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
